import type { ResearchStep } from './MessageResearch';
import { useStoreByMessageId } from './useStoreByMessageId';

export const useRoundedResearch = ({
	messageId,
}: {
	messageId: string;
}): {
	isThinkingDeeperRunning: boolean;
	rounds: {
		roundId: number;
		content: string;
		hasRounds: boolean;
	}[];
	maxRoundId: number | undefined;
} => {
	const [state] = useStoreByMessageId(messageId);

	const researchPlans = state?.researchPlans ?? {};
	const steps = Object.values(state?.steps ?? {});

	const stepsByRound = steps.reduce<{ [roundId: number]: ResearchStep[] }>((acc, step) => {
		if (!acc[step.roundId]) {
			acc[step.roundId] = [];
		}
		acc[step.roundId].push(step);
		return acc;
	}, {});

	const allRoundIds = [
		...new Set([
			...Object.keys(researchPlans).map(Number),
			...Object.keys(stepsByRound).map(Number),
		]),
	].sort((a, b) => a - b);

	const rounds = allRoundIds.map((roundId) => {
		return {
			roundId,
			content: researchPlans[roundId]?.content,
			hasRounds: stepsByRound[roundId]?.length > 0,
		};
	});

	return {
		isThinkingDeeperRunning: rounds.length > 0 && !state?.errored && !state?.researchCompleted,
		rounds,
		maxRoundId: allRoundIds.at(-1),
	};
};
